import { render } from "./PillButton.vue?vue&type=template&id=07af7687"
import script from "./PillButton.vue?vue&type=script&lang=js"
export * from "./PillButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__